module.exports = __webpack_public_path__ + "img/checkboxv2.3791c466.svg";